<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">售后退款记录</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="searchtitle">订单编号</span>
            <el-input
              placeholder="请输入"
              v-model="order_sn"
              style="width: 150px; margin-left: 8px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">处方号</span>
            <el-input
              placeholder="请输入"
              v-model="pre_id"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            ></el-input>
          </div>

          <div class="item">
            <span class="searchtitle">患者姓名</span>
            <el-input
              placeholder="请输入"
              v-model="user_name"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">药房名称</span>
            <!-- <el-input
              placeholder="请输入"
              v-model="hospital_name"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            ></el-input> -->
            <myInputSerch v-model="hospital_name" @update="search" style="margin:0 10px 0 10px;"></myInputSerch>

          </div>
          <div class="item">
            <span class="searchtitle">支付时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              clearable
              @change="search"
              style="width: 225px; margin-left: 8px"
            ></el-date-picker>
          </div>

          <div class="item">
            <span class="searchtitle">支付方式</span>
            <el-select
              v-model="pay_type"
              placeholder="请选择"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            >
              <el-option
                v-for="(item, index) in pay_type_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="searchtitle">支付来源</span>
            <el-select
              v-model="pay_from"
              placeholder="请选择"
              style="width: 150px; margin-left: 8px"
              clearable
              @change="search"
            >
              <el-option
                v-for="(item, index) in pay_from_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="searchtitle">退款时间</span>
            <el-date-picker
              v-model="date2"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              clearable
              @change="search"
              style="width: 225px; margin-left: 8px"
            ></el-date-picker>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 12px;
              "
              @click="search"
            >查询</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="退款时间"
              prop="refund_time"
            >
            </el-table-column>
            <el-table-column
              label="订单编号"
              prop="order_sn"
            >
            </el-table-column>
            <el-table-column
              label="处方号"
              prop="pre_id"
            > </el-table-column>
            <el-table-column
              label="药房名称"
              prop="hospital_name"
            >
            </el-table-column>
            <el-table-column
              label="患者姓名"
              prop="user_name"
            >
            </el-table-column>
            <el-table-column label="医生姓名">
              <template slot-scope="scope">
                <span
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="订单金额"
              prop="pay_money"
            >
            </el-table-column>
            <el-table-column
              label="支付时间"
              prop="pay_time"
            >
            </el-table-column>
            <el-table-column label="支付方式">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_type == 1">微信支付</span>
                <span v-if="scope.row.pay_type == 2">支付宝支付</span>
                <span v-if="scope.row.pay_type == 10">线下支付</span>
              </template>
            </el-table-column>
            <el-table-column label="支付来源">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_from == 1">公众号</span>
                <span v-if="scope.row.pay_from == 2">app</span>
                <span v-if="scope.row.pay_from == 3">小程序</span>
              </template>
            </el-table-column>
            <el-table-column
              label="售后退款"
              prop="refund_money"
            >
            </el-table-column>

            <el-table-column
              label="退款原因"
              prop="refund_remark"
            >
            </el-table-column>
            <el-table-column
              label="备注"
              prop="refund_desc"
            >
            </el-table-column>
          </el-table>
        </div>

        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from '@/components/myInputSerch';
import dayjs from 'dayjs';
import Pagination from '@/components/Pagination';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  inject: ['reload'],
  components: {
    Pagination,
    DocMsg,
    myInputSerch
  },
  data() {
    return {
      totalNum: 0,
      tableData: [],
      pagination: {
        page: 1,
        pageNumber: 10
      },
      order_sn: '',
      pre_id: '',
      user_name: '',
      doctor_name: '',
      hospital_name: '',
      pay_type: '',
      pay_from: '',
      date: [],
      date2: [],
      pay_type_list: [
        {
          label: '微信支付',
          value: 1
        },
        {
          label: '支付宝支付',
          value: 2
        },
        {
          label: '线下支付',
          value: 10
        }
      ],
      pay_from_list: [
        {
          label: '公众号',
          value: 1
        },
        {
          label: 'app',
          value: 2
        },
        {
          label: '小程序',
          value: 3
        }
      ],
      doc_msg: false,
      doctorId: ''
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        order_sn: this.order_sn,
        pre_id: this.pre_id,
        user_name: this.user_name,
        doctor_name: this.doctor_name,
        hospital_name: this.hospital_name,
        pay_type: this.pay_type,
        pay_from: this.pay_from,
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber
      };
      if (this.date && this.date.length > 0) {
        data.pay_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.pay_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      if (this.date2 && this.date2.length > 0) {
        data.refund_time_start = dayjs(this.date2[0]).format('YYYY-MM-DD');
        data.refund_time_end = dayjs(this.date2[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/order/afterSalesrefundList', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.tableData = res.data.list.map((item) => {
            item.refund_time = dayjs
              .unix(item.refund_time)
              .format('YYYY-MM-DD HH:mm');
            item.pay_time = dayjs
              .unix(item.pay_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
        });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .searchtitle {
    display: inline-block;
    width: 60px;
    text-align: right;
    box-sizing: border-box;
  }
  .item {
    margin-right: 10px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
</style>


